import React, { useEffect, useLayoutEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Invest from "../pages/Invest";
import Faq from "../pages/others/Faq";
import Regularv1 from "../pages/others/Regular-1";
import Regularv2 from "../pages/others/Regular-2";
import Terms from "../pages/others/Terms";
import UserProfileRegular from "../pages/pre-built/user-manage/UserProfileRegular";
import UserProfileSetting from "../pages/pre-built/user-manage/UserProfileSetting";
import UserProfileNotification from "../pages/pre-built/user-manage/UserProfileNotification";
import UserProfileActivity from "../pages/pre-built/user-manage/UserProfileActivity";

import Error404Modern from "../pages/error/404-modern";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import Success from "../pages/auth/Success";

import Layout from "../layout/Index";
import LayoutNoSidebar from "../layout/Index-nosidebar";

//Procurex Pages

import ViewPurchaseRequests from "../pages/purchase-requests/ViewPurchaseRequests";
import PurchaseRequestAprrovals from "../pages/purchase-requests/PurchaseRequestApprovals";
import PurchaseRequestAnalytics from "../pages/purchase-requests/PurchaseRequestAnalytics";
import TrackPurchaseRequests from "../pages/purchase-requests/TrackPurchaseRequests";

import ViewBudgetList from "../pages/budget/ViewBudget";
import TrackBudget from "../pages/budget/TraclBudget";
import BudgetApprovals from "../pages/budget/BudgetApprovals";
import BudgetAnalytics from "../pages/budget/BudgetAnalytics";

import RFQCreation from "../pages/quotations/RFQCreations";
import RFQAnalytics from "../pages/quotations/RFQAnalytics";
import RFQApprovals from "../pages/quotations/RFQApprovals";
import RFQComparison from "../pages/quotations/RFQComparison";
import RFQConversion from "../pages/quotations/RFQConversion";
import RFQView from "../pages/quotations/RFQView";
import VersionControl from "../pages/quotations/rfq-version-control/versionControl";
import RFQTracking from "../pages/quotations/RFQTracking";
import RFQFullView from "../pages/quotations/quotationView/RFQFullView";
import SitesSetup from "../pages/masters/sites/SitesSetup";
import AddSites from "../pages/masters/sites/CreateSites";
import SitesViewDetails from "../pages/masters/sites/SitesViewDetails";
import Departments from "../pages/masters/departments/Departments";
import Roles from "../pages/masters/roles/Roles";
import ReportingHeirarchy from "../pages/masters/roles/ReportingHeirarchy";
import SupplierCategory from "../pages/masters/supplier/SupplierCategory";
import Suppliers from "../pages/masters/supplier/Suppliers";
import Contractors from "../pages/masters/contractors/Contractors";
import ViewSuppliersDetails from "../pages/masters/supplier/ViewSuppliersDetails";
import AddContractors from "../pages/masters/contractors/AddContractors";
import ViewContractorDetails from "../pages/masters/contractors/ViewContractorDetails";
import ApprovalHeirarchy from "../pages/masters/contractors/ApprovalHeirarchy";
import MaterialCategory from "../pages/masters/materials/MaterialCategory";
import Materials from "../pages/masters/materials/Material";
import UomPage from "../pages/masters/Uom/UomPage";

import CostCenter from "../pages/masters/cost-center/CostCenter";
import GeneralLedger from "../pages/masters/general-ledger/GeneralLedger";
import Consultants from "../pages/masters/consultants/Consultants";
import Users from "../pages/masters/Users/Users";
import CreateUsers from "../pages/masters/Users/CreateUsers";
import AddSupplier from "../pages/masters/supplier/AddSupplier";
import AddConsultants from "../pages/masters/consultants/AddConsultants";
import AddMaterial from "../pages/masters/materials/AddMaterial";
import ViewMaterialDetails from "../pages/masters/materials/ViewMaterialDetails";
import ViewConsultantDetails from "../pages/masters/consultants/ViewConsultantDetails";
import CreateRole from "../pages/masters/roles/CreateRole";
import UserViewDetails from "../pages/masters/Users/ViewUser";
import RoleViewDetails from "../pages/masters/roles/ViewRole";
import ViewOrgPage from "../pages/masters/orgmaster/ViewOrg";
import SetPassword from "../pages/auth/SetPassword";
import SuccessMain from "../pages/auth/SuccessMain";
import EmailError from "../pages/auth/EmailError";
import ResetPassword from "../pages/auth/ResetPassword";
import OrgLegalInformation from "../pages/masters/orgmaster/OrgLegalInformation";
import OrgContactInformation from "../pages/masters/orgmaster/orgContactInformation";
import OrgBankInformation from "../pages/masters/orgmaster/OrgBankInformation";

import PurchaseOrderMain from "../pages/purchase-orders/PurchaseOrderMain";
import DeliveryAddress from "../pages/masters/delivery-address/DeliveryAddress";
import ViewPurchaseOrdersList from "../pages/purchase-orders/ViewPurchaseOrder";
import TrackPurchaseOrder from "../pages/purchase-orders/TrackPurchaseOrder";
import PurchaseOrderAnalytics from "../pages/purchase-orders/PurchaseOrderAnalytics";
import PurchaseOrderAprrovals from "../pages/purchase-orders/PurchaseOrderApprovals";
import BudgetCreation from "../pages/budget/BudgetCreations";
import PendingApprovalBudget from "../pages/budget/PendingApprovalBudget";
import ViewInvoiceList from "../pages/invoice/ViewAllInvoices";
import ViewInvoiceDetails from "../pages/invoice/ViewInvoiceDetails";
import InvoiceApproval from "../pages/invoice/InvoiceApproval";
import TrackInvoice from "../pages/invoice/TrackInvoice";
import InvoiceAnalytics from "../pages/invoice/InvoiceAnalytics";
import QCApprovals from "../pages/quotations/QCApprovals";
import ReadyToAward from "../pages/quotations/ReadyToAward";
import ViewDetailsEdit from "../pages/quotations/ViewDetailsEdit";
import ViewAllDispatch from "../pages/dispatch/ViewAllDispatch";
import ShowDispatchDetailsWrapper from "../pages/dispatch/showDispatchDetailsWrapper";
import ViewAllDeliveredGRN from "../pages/dispatch/ViewAllDeliveredGRN";
import InvoicePayables from "../pages/payments/invoicePayables";
import PendingPaymentApprovals from "../pages/payments/pendingPaymentApprovals";
import RunPayments from "../pages/payments/runPayments";
import ViewPayments from "../pages/payments/viewPayments";
import Main from "../pages/credit-debit-note/Main";
import ViewAllCN from "../pages/credit-debit-note/ViewAllCN";
import ViewPendingApprovalCN from "../pages/credit-debit-note/ViewPendingApprovalCN";
import NewPurchaseRequestMain from "../pages/purchase-requests/NewPRMain";
import ViewPRDetails from "../pages/purchase-requests/ViewPRDetails";
import TrackPRList from "../pages/purchase-requests/TrackPRList";
import PurchaseOrderApprovalsWrapper from "../pages/purchase-orders/PurchaseOrderApprovalsWrapper";
import PurchaseOrderViewWrapper from "../pages/purchase-orders/PurchaseOrderViewWrapper";
import { useDispatch } from "react-redux";
import { fetchCurrentUser } from "../store/slices/misc/currentUser";

import PaymentsAnalytics from "../pages/payments/PaymentsAnalytics";
import SequenceList from "../pages/masters/sequence/SequenceList";
import { useSelector } from "react-redux";
import { updateAccessibility } from "../store/slices/misc/accessibility";
import { updateMenuData } from "../store/slices/misc/menuData";
import { Flex, Spin } from "antd";
import { updateAllowedRoutes } from "../store/slices/misc/allowedRoutes";
import PoInvoiceDetails from "../pages/purchase-orders/OrderToInvoiceCreation";
import ViewMaterialInvoices from "../pages/invoice/ViewMaterialInvoices";
import { fetchSequenceAccess } from "../store/slices/misc/sequenceAccess";
import ViewBudgetDetails from "../pages/budget/ViewBudgetDetails";
import Cookies from "js-cookie";
import QCList from "../pages/quotations/QCList";
import MaterialIssue from "../pages/inventory/MaterialIssue";
import SiteIssue from "../pages/inventory/SiteIssue";
import InventoryPendingApproval from "../pages/inventory/PendingApprovals";
import ViewAllReportsList from "../pages/reports/view-all-reports";
import PurchaseOrderReports from "../pages/reports/purchase-reports/purchaseOrderReports";
import PurchaseOrderPreview from "../pages/reports/purchase-reports/purchaseOrderPreview";
import PurchaseBySupplier from "../pages/reports/purchase-reports/purchaseBySupplier";
import PurchaseBySupplierDetailReport from "../pages/reports/purchase-reports/purchaseBySupplierDetailReport";
import PurchaseByMaterialReport from "../pages/reports/purchase-reports/purchaseByMaterialReport";
import PurchaseByMaterialDetailReport from "../pages/reports/purchase-reports/purchaseByMaterialDetailReport";
import PurchaseByCategoryReport from "../pages/reports/purchase-reports/purchaseByCategoryReport";
import OrderDetailsByCategoryReport from "../pages/reports/purchase-reports/orderDetailsByCategoryReport";
import PurchaseBySiteReport from "../pages/reports/purchase-reports/purchaseBySiteReport";
import OrderDetailsBySiteReport from "../pages/reports/purchase-reports/orderDetailsBySiteReport";
import InvoiceBySupplierReport from "../pages/reports/purchase-reports/invoiceBySupplierReport";
import InvoicePreviewReport from "../pages/reports/purchase-reports/invoicePreviewReport";
import DeliveryNoteDetailsReport from "../pages/reports/purchase-reports/deliveryNoteDetailsReport";
import MaterialsByDeliveryNoteReport from "../pages/reports/purchase-reports/materialsByDeliveryNoteReport";
import SupplierPaymentsReport from "../pages/reports/accounts-payable-reports/supplierPaymentsReport";
import SupplierPaymentsInvoiceReport from "../pages/reports/accounts-payable-reports/supplierPaymentsInvoiceReport";
import PaymentsAgingSummaryReport from "../pages/reports/accounts-payable-reports/paymentsAgingSummaryReport";
import ApprovedMaterialReport from "../pages/reports/inventory-reports/approvedMaterialReport";
import MaterialsToSiteReport from "../pages/reports/inventory-reports/materialsToSiteReport";
import ReturnsFromSiteReport from "../pages/reports/inventory-reports/returnsFromSiteReport";
import InventorySummaryReport from "../pages/reports/inventory-reports/inventorySummaryReport";
import CommittedStockReport from "../pages/reports/inventory-reports/committedStockReport";
import InventoryValueReport from "../pages/reports/inventory-reports/inventoryValueReport";
import InventoryTrackReport from "../pages/reports/inventory-reports/inventoryTrackReport";
import InventoryAgingReport from "../pages/reports/inventory-reports/inventoryAgingReport";
import MaterialUtilizationReport from "../pages/reports/inventory-reports/materialUtilizationReport";
import StockSummaryReport from "../pages/reports/inventory-reports/stockSummaryReport";
import ABCClassification from "../pages/reports/inventory-reports/abcClassification";
import PaymentsAgingReport from "../pages/reports/accounts-payable-reports/paymentsAgingReport";
import PaymentsReport from "../pages/reports/accounts-payable-reports/paymentsReport";
import InvoiceDetailsForPaymentsReport from "../pages/reports/accounts-payable-reports/invoiceDetailsForPaymentsReport";
import InventoryValueReportPreview from "../pages/reports/inventory-reports/inventoryValueReportPreview";
import StockAvailabilityReport from "../pages/inventory/StockAvailabilityReport";
import MaterialDetails from "../pages/inventory/MaterialDetails";
import SupplierBalancesReport from "../pages/reports/accounts-payable-reports/supplierBalancesReport";
import SupplierBalancesDetailReport from "../pages/reports/accounts-payable-reports/supplierBalancesDetailReport";
import GRNPreview from "../pages/reports/purchase-reports/grnPreview";
import PaymentsAgingSummaryInvoiceReport from "../pages/reports/accounts-payable-reports/paymentsAgingSummaryInvoiceReport";
import BOQCreationMain from "../pages/boq/boqCreationMain";
import BOQList from "../pages/boq/boqList";
import BoqReport from "../pages/boq/boqReport";
import BoqViewDeatils from "../pages/boq/boqViewDetails";
import WorkBoqCreationMain from "../pages/work-boq/workBoqCreationMain";
import WorkBoqList from "../pages/work-boq/workBoqList";
import WorkBoqApprovals from "../pages/work-boq/workBoqApprovals";
import WorkBoqView from "../pages/work-boq/workBoqView";
import InventoryAnalytics from "../pages/inventory/InventoryAnalytics";
import ViewPendingApprovalsGRN from "../pages/dispatch/ViewPendingApprovalsGRN";
import ExcelExportRequestedList from "../pages/pre-built/user-manage/ExcelExportRequestedList";
import NotificationMain from "../pages/notifications/NotificationMain";
import BudgetTrackReport from "../pages/reports/budget-reports/budgetTrackReport";
import MaterialConsumptionReport from "../pages/reports/budget-reports/materialConsumptionReport";
import MaterialRequestSummaryList from "../pages/reports/material-management-reports/materialRequestSummaryList";
import MaterialIssueSummary from "../pages/reports/material-management-reports/materialIssueSummary";
import MaterialUtilizedSummary from "../pages/reports/material-management-reports/materialUtilizedSummary";
import MaterialDamageSummary from "../pages/reports/material-management-reports/materialDamageSummary";
import MaterialSummary from "../pages/reports/material-management-reports/materialSummary";
import MaterialSummaryDetailReport from "../pages/reports/MaterialSummaryDetailReport";
import MaterialConsumptionDetailReport from "../pages/reports/MaterialConsumptionDetailReport";
import ViewBoqDetails from "../pages/boq/boqViewDetails";
import WorkCategory from "../pages/masters/WorkCategory/WorkCategory";
import VersionControlDefaultTemplate from "../pages/version-control/versionControlDefaultTemplate";
import POVersionControl from "../pages/purchase-orders/POVersionControl";
import PRVersionControl from "../pages/purchase-requests/PRVersionControl";
import BulkUploadList from "../pages/pre-built/user-manage/ExcelUploadRequestedList";
import DefaultDashboardPage from "../pages/DefaultDashboard";
import { HomeOutlined } from "@ant-design/icons";
import RateContractMain from "../pages/rate-contract/RateContractMain";
import RateContractAprrovals from "../pages/rate-contract/RateContractApprovals";
import ViewRateContractsList from "../pages/rate-contract/ViewRateContract";
import RateContractViewWrapper from "../pages/rate-contract/RateContractViewWrapper";
import RateContractApprovalsWrapper from "../pages/rate-contract/RateContractApprovalsWrapper";
import WorkRequestList from "../pages/work-requests/workRequestList";
import WorkRequestCreationMain from "../pages/work-requests/workRequestCreationMain";
import WorkRequestApprovals from "../pages/work-requests/workRequestApprovals";
import WorkRequestView from "../pages/work-requests/workRequestView";
import ViewWorkOrder from "../pages/work-orders/ViewWorkOrder";
import WorkOrderView from "../pages/work-orders/workOrderView";
import PendingWorkOrderApprovals from "../pages/work-orders/PendingWorkOrderApprovals";
import NewWorkOrders from "../pages/work-orders/NewWorkOrders";
import WorkOrderDetails from "../pages/work-orders/WorkOrderDetails";
import WorkOrderAmendment from "../pages/work-orders/WorkOrderAmendment";
import FinalizedWorkOrders from "../pages/work-orders/FinalizedWorkOrders";
import ViewAllWorkOrders from "../pages/work-orders/ViewAllWorkOrders";
import WorkOrderViewDetails from "../pages/work-orders/workOrderViewDetails";

// Work Execution imports
import WorkExecutionUpdates from "../pages/work-execution/WorkExecutionUpdates";
import WorkExecutionApprovals from "../pages/work-execution/WorkExecutionApprovals";
import WorkExecutionClosedWorks from "../pages/work-execution/WorkExecutionClosedWorks";
import WorkExecutionWorkOrderDetails from "../pages/work-execution/WorkExecutionWorkOrderDetails";
import WorkExecutionBatchDetails from "../pages/work-execution/WorkExecutionBatchDetails";
import WorkExecutionApprovedLineHistory from "../pages/work-execution/WorkExecutionApprovedLineHistory";

// RA Bills imports
import CreateRABills from "../pages/ra-bills/CreateRABills";
import CreateRABillDetails from "../pages/ra-bills/CreateRABillDetails";
import RABillsPendingApprovals from "../pages/ra-bills/RABillsPendingApprovals";
import ViewRABillsApproved from "../pages/ra-bills/ViewRABillsApproved";
import RABillsOutstanding from "../pages/ra-bills/RABillsOutstanding";
import RABillsOverdue from "../pages/ra-bills/RABillsOverdue";
import RABillDetails from "../pages/ra-bills/RABillDetails";
import CreatePayment from "../pages/payments/CreatePayment";
const globalRoutes = [
  "/",
  "/auth-reset",
  "/auth-success",
  "/auth-register",
  "/setPassword",
  "/success",
  "/errorEmail",
  "/privacy",
  // "/notifications",
];
const routesMap = {
  dashboard: <Invest />,
  organisation: <ViewOrgPage />,
  orgLegalInformation: <OrgLegalInformation />,
  orgContactInformation: <OrgContactInformation />,
  orgBankInformation: <OrgBankInformation />,
  sites: <SitesSetup />,
  createSites: <AddSites />,
  // notifications: <NotificationMain />,
  "delivery-address": <DeliveryAddress />,
  sequence: <SequenceList />,
  "sitesViewDetails/:siteId": <SitesViewDetails />,
  departments: <Departments />,
  roles: <Roles />,
  "ViewRoleDetails/:roleID": <RoleViewDetails />,
  "reporting-hierarchy": <ReportingHeirarchy />,
  "supplier-category": <SupplierCategory />,
  "work-category": <WorkCategory />,
  suppliers: <Suppliers />,
  addSuppliers: <AddSupplier />,
  "vewSuppliersDetails/:siteId": <ViewSuppliersDetails />,
  "general-contractors": <Contractors />,
  "viewContractorDetails/:siteId": <ViewContractorDetails />,
  addContractors: <AddContractors />,
  addConsultants: <AddConsultants />,
  "viewConsultantDetails/:consultantId": <ViewConsultantDetails />,
  addMaterials: <AddMaterial />,
  "vewMaterialDetails/:materialId": <ViewMaterialDetails />,
  consultants: <Consultants />,
  users: <Users />,
  createUsers: <CreateUsers />,
  "userProfile/:userId": <UserViewDetails />,
  createRole: <CreateRole />,
  "approval-heirarchy": <ApprovalHeirarchy />,
  "materail-category": <MaterialCategory />,
  materails: <Materials />,
  uom: <UomPage />,
  "cost-center": <CostCenter />,
  "general-ledger": <GeneralLedger />,
  "add-new-purchase-request": <NewPurchaseRequestMain />,
  "approvals-purchase-request": <PurchaseRequestAprrovals />,
  "view-purchase-requests": <ViewPurchaseRequests />,
  "track-purchase-requests/:prId": <TrackPurchaseRequests />,
  "analytics-purchase-requests": <PurchaseRequestAnalytics />,
  "view_pr/:prId": <ViewPRDetails />,
  prHistory: <PRVersionControl />,
  "track-list": <TrackPRList />,
  "new-budget": <BudgetCreation />,
  "budget-approvals": <BudgetApprovals />,
  "view-budget": <ViewBudgetList />,
  "pendingApproval-budget": <PendingApprovalBudget />,
  "track-budget": <TrackBudget />,
  "analytics-budget": <BudgetAnalytics />,
  "view_budget_details/:budgetId": <ViewBudgetDetails />,
  "new-rfq": <RFQCreation />,
  "qc-list": <QCList />,
  "rfq-approvals": <RFQApprovals />,
  "qc-approvals": <QCApprovals />,
  "view-rfqs": <RFQView />,
  viewhistory: <VersionControl />,
  // viewhistory: <VersionControlDefaultTemplate />,
  "track-rfqs": <RFQTracking />,
  "analytics-rfq": <RFQAnalytics />,
  "rfq-comparison": <RFQComparison />,
  "rfq-conversion": <RFQConversion />,
  "rfq-full-view": <RFQFullView />,
  "ready-to-award": <ReadyToAward />,
  "view/:qid": <ViewDetailsEdit />,
  "purchase-order-new": <PurchaseOrderMain />,
  "approvals-purchase-order": <PurchaseOrderAprrovals />,
  "approvals-purchase-order/:orderNumber": <PurchaseOrderApprovalsWrapper />,
  "view-purchase-order": <ViewPurchaseOrdersList />,
  "view-purchase-order/:orderNumber": <PurchaseOrderViewWrapper />,
  "poHistory/:orderNumber": <POVersionControl />,
  "track-purchase-order": <TrackPurchaseOrder />,
  "analytics-purchase-order": <PurchaseOrderAnalytics />,
  "rate-contract-new": <RateContractMain />,
  "approvals-rate-contract": <RateContractAprrovals />,
  "approvals-rate-contract/:orderNumber": <RateContractApprovalsWrapper />,
  "view-rate-contract": <ViewRateContractsList />,
  "view-rate-contract/:orderNumber": <RateContractViewWrapper />,
  "credit-debit-note-new": <Main />,
  "all-credit-debit-notes": <ViewAllCN />,
  "pending-approval-credit-debit-notes": <ViewPendingApprovalCN />,
  "invoice-payables": <InvoicePayables />,
  "add-purchase-invoice/:orderNumber": <PoInvoiceDetails />,
  "pending-payment-approvals": <PendingPaymentApprovals />,
  "run-payments": <RunPayments />,
  "view-payments": <ViewPayments />,
  "payment-analytics": <PaymentsAnalytics />,
  "view-material-invoices/:orderNumber/:lineNo": <ViewMaterialInvoices />,
  "view-invoice-list": <ViewInvoiceList />,
  "view-invoice/:id": <ViewInvoiceDetails />,
  "approvals-purchase-invoice": <InvoiceApproval />,
  "track-purchase-invoice": <TrackInvoice />,
  "analytics-purchase-invoice": <InvoiceAnalytics />,
  "view-dispatch-list": <ViewAllDispatch />,
  "delivered-dispatch-list": <ViewAllDeliveredGRN />,
  "pending-approvals-grn-list": <ViewPendingApprovalsGRN />,
  "view-dispatch-details/:id": <ShowDispatchDetailsWrapper />,
  "payments-analytics": <PaymentsAnalytics />,
  "terms-policy": <Terms />,
  faq: <Faq />,
  privacy: <Faq />,
  "pages/regular-v1": <Regularv1 />,
  "pages/regular-v2": <Regularv2 />,
  "material-issue": <MaterialIssue />,
  "site-inventory": <SiteIssue />,
  "materialIssue-pending-approvals": <InventoryPendingApproval />,
  "dashboard-inventory": <InventoryAnalytics />,

  "view-inventory-reports": <ViewAllReportsList />,
  "inventory-approved-material-reports-list": <ApprovedMaterialReport />,
  "inventory-materials-to-site-reports-list": <MaterialsToSiteReport />,
  "inventory-returns-from-site-reports-list": <ReturnsFromSiteReport />,
  "inventory-summary-reports-list": <InventorySummaryReport />,
  "inventory-committed-stock-report-list/:id/:historyId": (
    <CommittedStockReport />
  ),
  "inventory-value-report-list": <InventoryValueReport />,
  "inventory-track-report-list": <InventoryTrackReport />,
  "inventory-aging-report-list": <InventoryAgingReport />,
  "inventory-material-utilization-report-list": <MaterialUtilizationReport />,
  "inventory-stock-summary-report-list": <StockSummaryReport />,
  "inventory-abc-classification-report-list": <ABCClassification />,
  "inventory-value-report-preview/:id/:historyId": (
    <InventoryValueReportPreview />
  ),
  "stock-availability": <StockAvailabilityReport />,
  "view-material-issue-details/:id": <MaterialDetails />,

  "create-consumption-target": <BOQCreationMain />,

  "consumption-target-list": <BOQList />,

  "consumption_target_view/:targetId": <BoqViewDeatils />,

  "consumption-target-Report": <BoqReport />,

  "work-boq-creation": <WorkBoqCreationMain />,
  "work-request-creation": <WorkRequestCreationMain />,
  "work-boq-list": <WorkBoqList />,
  "work-request-list": <WorkRequestList />,
  "work-boq-approvals": <WorkBoqApprovals />,
  "work-request-approvals": <WorkRequestApprovals />,
  "work-boq-view/:id": <WorkBoqView />,
  "work-request-view/:id": <WorkRequestView />,
  "view-work-orders": <ViewAllWorkOrders />,
  "New-work-order": <NewWorkOrders />,
  "work-order-details/:id": <WorkOrderDetails />,
  "work-order-contractor-approvals": <WorkOrderAmendment />,
  "work-order-execution": <FinalizedWorkOrders />,
  "work-order-view/:id": <WorkOrderView />,
  "work-order-approvals": <PendingWorkOrderApprovals />,
  "view-work-order-details/:id": <WorkOrderViewDetails />,

  // Work Execution routes
  "work-execution-under-execution": <WorkExecutionUpdates />,
  "work-execution-pending-approvals": <WorkExecutionApprovals />,
  "work-execution-closed-works": <WorkExecutionClosedWorks />,
  "work-execution-work-order-details/:id": <WorkExecutionWorkOrderDetails />,
  "work-execution-batch-details/:id": <WorkExecutionBatchDetails />,
  "work-execution-approved-line-history/:id": (
    <WorkExecutionApprovedLineHistory />
  ),

  // RA Bills routes
  "ra-bills-create": <CreateRABills />,
  "ra-bills-create-detail/:woId": <CreateRABillDetails />,
  "ra-bills-pending-approvals": <RABillsPendingApprovals />,
  "ra-bills-view-approved": <ViewRABillsApproved />,
  "ra-bills-outstanding": <RABillsOutstanding />,
  "ra-bills-overdue": <RABillsOverdue />,
  "ra-bills-view-details/:id": <RABillDetails />,
  "ra-bills-approval-details/:id": <RABillDetails />,

  "view-purchase-reports": <ViewAllReportsList />,
  "view-accounts-payable-reports": <ViewAllReportsList />,
  "purchase-order-report-preview/:orderNumber": <PurchaseOrderPreview />,
  "purchase-order-reports-list": <PurchaseOrderReports />,

  "purchase-by-supplier-reports-list": <PurchaseBySupplier />,
  "purchase-by-supplier-detail-report/:id": <PurchaseBySupplierDetailReport />,

  "purchase-by-material-reports-list": <PurchaseByMaterialReport />,
  "purchase-by-material-reports-detail-report/:id": (
    <PurchaseByMaterialDetailReport />
  ),

  "purchase-by-category-reports-list": <PurchaseByCategoryReport />,
  "order-details-by-category-report/:id": <OrderDetailsByCategoryReport />,
  // "invoice-details-by-category-report/:id": <InvoiceDetailsByCategoryReport />,

  "purchase-by-site-reports-list": <PurchaseBySiteReport />,
  "order-details-by-site-report/:id": <OrderDetailsBySiteReport />,
  // "invoice-details-by-site-report/:id": <InvoiceDetailsBySiteReport />,

  "invoice-by-supplier-reports-list": <InvoiceBySupplierReport />,
  "invoice-preview-report/:id": <InvoicePreviewReport />,

  "delivery-note-details": <DeliveryNoteDetailsReport />,
  "materials-by-delivery-note-report/:id": <MaterialsByDeliveryNoteReport />,

  "supplier-payments-reports-list": <SupplierPaymentsReport />,
  "supplier-payments-invoice-report/:id": <SupplierPaymentsInvoiceReport />,

  "payment-aging-summary-reports-list": <PaymentsAgingSummaryReport />,
  "payments-aging-summary-invoice-report/:id": (
    <PaymentsAgingSummaryInvoiceReport />
  ),

  "payment-aging-reports-list": <PaymentsAgingReport />,
  "payment-reports-list": <PaymentsReport />,
  "invoice-details-for-payments-report/:id": (
    <InvoiceDetailsForPaymentsReport />
  ),

  "supplier-balances-report": <SupplierBalancesReport />,
  "supplierBalancesDetailReport/:id": <SupplierBalancesDetailReport />,
  "grn-preview-report/:id": <GRNPreview />,

  "view-budget-reports": <ViewAllReportsList />,
  "consumption_target_view/:targetId": <ViewBoqDetails />,
  "view-material-management-reports": <ViewAllReportsList />,
  "material-tracking-report-list": <BudgetTrackReport />,
  "material-consumption-report-list": <MaterialConsumptionReport />,
  "material-consumption-detail-report": <MaterialConsumptionDetailReport />,

  "material-request-summary-list": <MaterialRequestSummaryList />,
  "material-issue-summary-list": <MaterialIssueSummary />,
  "material-utilized-summary-list": <MaterialUtilizedSummary />,
  "material-damage-summary-list": <MaterialDamageSummary />,
  "material-summary-list": <MaterialSummary />,
  viewhistory: <VersionControlDefaultTemplate />,
  "material-summary-list-detail-report": <MaterialSummaryDetailReport />,

  "create-payment": <CreatePayment />,
  "pending-payment-approvals": <PendingPaymentApprovals />,
  "run-payments": <RunPayments />,
  "view-payments": <ViewPayments />,
  // "auth-success": <Success />,
  // "auth-reset": <ResetPassword />,
  // "auth-register": <Register />,
  // setPassword: <SetPassword />,
  // success: <SuccessMain />,
  // errorEmail: <EmailError />,
  // "errors/404-modern": <Error404Modern />,
  // "errors/404-classic": <Error404Classic />,
  // "errors/504-modern": <Error504Modern />,
  // "errors/504-classic": <Error504Classic />,
  // "invoice-print/:invoiceId": <InvoicePrint />,
  "*": <Error404Modern />,
};
const menu = [
  {
    text: "Dashboard",
    link: "dashboard",
  },
  {
    text: "Work Order",
    link: "view-work-orders",
  },
  {
    text: "Work Execution",
    link: "work-execution-under-execution",
  },
  {
    text: "RA Bills",
    link: "ra-bills-create",
  },
  {
    text: "Payment",
    link: "view-payments",
  },
];
const Pages = ({ setIsLoggedIn }) => {
  const { data: currentUser } = useSelector((state) => state.currentUser);
  const [accessibility, setAccessibility] = useState([]);
  const [restrictedRoutes, setRestrictedRoutes] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const isAuthenticated = Cookies.get("access-token");
    if (
      !currentUser &&
      isAuthenticated &&
      !globalRoutes?.includes(window.location.pathname)
    ) {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch]);

  useEffect(() => {
    if (currentUser?.userRoutePermissions) {
      try {
        dispatch(fetchSequenceAccess());
        const { userRoutePermissions } = currentUser;
        // const decodedString = atob(userRoutePermissions);
        const decodedString = {
          KYC: {
            menuItem: "KYC",
            access: true,
            routes: [
              { path: "kyc-list-regular", permission: true, pageType: "view" },
              {
                path: "kyc-details-regular/:kycId",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Pages: {
            menuItem: "Pages",
            access: true,
            routes: [
              { path: "terms-policy", permission: true, pageType: "view" },
              { path: "faq", permission: true, pageType: "view" },
              { path: "regular-v1", permission: true, pageType: "view" },
              { path: "regular-v2", permission: true, pageType: "view" },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Authentication: {
            menuItem: "Authentication",
            access: true,
            routes: [
              { path: "auth-success", permission: true, pageType: "view" },
              { path: "auth-reset", permission: true, pageType: "view" },
              { path: "auth-register", permission: true, pageType: "add" },
              { path: "setPassword", permission: true, pageType: "add" },
              { path: "success", permission: true, pageType: "view" },
              { path: "errorEmail", permission: true, pageType: "view" },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Errors: {
            menuItem: "Errors",
            access: true,
            routes: [
              { path: "errors/404-modern", permission: true, pageType: "view" },
              {
                path: "errors/404-classic",
                permission: true,
                pageType: "view",
              },
              { path: "errors/504-modern", permission: true, pageType: "view" },
              {
                path: "errors/504-classic",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Dashboard: {
            menuItem: "Dashboard",
            access: true,
            routes: [{ path: "dashboard", permission: true, pageType: "view" }],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          WorkBOQ: {
            menuItem: "Work BOQ",
            access: true,
            routes: [
              { path: "work-boq-list", permission: true, pageType: "view" },
              { path: "work-boq-creation", permission: true, pageType: "add" },
              {
                path: "work-boq-view/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-boq-approvals",
                permission: true,
                pageType: "approve",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          WorkRequest: {
            menuItem: "Work Request",
            access: true,
            routes: [
              { path: "work-request-list", permission: true, pageType: "view" },
              {
                path: "work-request-creation",
                permission: true,
                pageType: "add",
              },
              {
                path: "work-request-view/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-request-approvals",
                permission: true,
                pageType: "approve",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          payment: {
            menuItem: "Payment",
            access: true,
            routes: [
              {
                path: "create-payment",
                permission: true,
                pageType: "add",
              },
              {
                path: "pending-payment-approvals",
                permission: true,
                pageType: "approve",
              },
              {
                path: "run-payments",
                permission: true,
                pageType: "edit",
              },
              {
                path: "view-payments",
                permission: true,
                pageType: "view",
              },
              {
                path: "payment-analytics",
                permission: true,
                pageType: "view",
              },
              {
                path: "invoice-payables",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          WorkOrder: {
            menuItem: "Work Order",
            access: true,
            routes: [
              { path: "view-work-orders", permission: true, pageType: "view" },
              {
                path: "work-order-view/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-order-contractor-approvals",
                permission: true,
                pageType: "view",
              },
              {
                path: "New-work-order",
                permission: true,
                pageType: "view",
              },
              {
                path: "view-work-order-details/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-order-execution",
                permission: true,
                pageType: "approve",
              },
              {
                path: "work-execution-under-execution",
                permission: true,
                pageType: "edit",
              },
              {
                path: "work-execution-pending-approvals",
                permission: true,
                pageType: "approve",
              },
              {
                path: "work-execution-closed-works",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-execution-work-order-details/:id",
                permission: true,
                pageType: "edit",
              },
              {
                path: "work-execution-batch-details/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-execution-approved-line-history/:id",
                permission: true,
                pageType: "view",
              },
              // RA Bills permissions
              {
                path: "ra-bills-create",
                permission: true,
                pageType: "edit",
              },
              {
                path: "ra-bills-create-detail/:woId",
                permission: true,
                pageType: "edit",
              },
              {
                path: "ra-bills-pending-approvals",
                permission: true,
                pageType: "approve",
              },
              {
                path: "ra-bills-view-approved",
                permission: true,
                pageType: "view",
              },
              {
                path: "ra-bills-outstanding",
                permission: true,
                pageType: "view",
              },
              {
                path: "ra-bills-overdue",
                permission: true,
                pageType: "view",
              },
              {
                path: "ra-bills-view-details/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "ra-bills-approval-details/:id",
                permission: true,
                pageType: "approve",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
        };
        console.log("decodedString", decodedString);
        const decodedData = decodedString;
        console.log("decodedData", decodedData);
        dispatch(updateAccessibility(decodedData));
        const _allowedRoutes = [];
        const _restrictedRoutes = [];
        Object.keys(decodedData).forEach((mod) => {
          const module = decodedData[mod];
          if (module?.access) {
            module?.routes?.forEach((route) => {
              if (route?.permission) {
                _allowedRoutes.push(route?.path);
              } else {
                _restrictedRoutes.push(route?.path);
              }
            });
          }
        });
        setAccessibility(_allowedRoutes);
        setRestrictedRoutes(_restrictedRoutes);
        const _menu = [];
        menu?.forEach((item) => {
          if (item?.subMenu?.length > 0) {
            const subMenu = [];
            item?.subMenu?.forEach((subItem) => {
              if (subItem?.subMenu?.length > 0) {
                const _subMenuChildren = [];
                subItem?.subMenu?.forEach((subSubItem) => {
                  if (_allowedRoutes.includes(subSubItem?.link)) {
                    _subMenuChildren.push({
                      text: subSubItem?.text,
                      link: subSubItem?.link,
                      icon: subSubItem?.icon,
                    });
                  }
                });
                if (_subMenuChildren.length > 0) {
                  subMenu.push({
                    text: subItem?.text,
                    icon: subItem?.icon,
                    active: false,
                    subMenu: _subMenuChildren,
                  });
                }
                return;
              }
              if (_allowedRoutes.includes(subItem?.link)) {
                subMenu.push({
                  text: subItem?.text,
                  icon: subItem?.icon,
                  link: subItem?.link,
                });
              } else {
                if (subItem?.alt?.length > 0) {
                  const altLink = subItem?.alt?.find((link) =>
                    _allowedRoutes.includes(link)
                  );
                  if (altLink) {
                    subMenu.push({
                      text: subItem?.text,
                      icon: subItem?.icon,
                      link: altLink,
                    });
                  }
                }
              }
            });
            if (subMenu.length > 0) {
              _menu.push({
                text: item?.text,
                subMenu: subMenu,
                icon: item?.icon,
              });
            }
          } else {
            if (_allowedRoutes.includes(item?.link)) {
              _menu.push({
                text: item?.text,
                link: item?.link,
                icon: item?.icon,
              });
            } else if (item?.alt?.length > 0) {
              const altLink = item?.alt?.find((link) =>
                _allowedRoutes.includes(link)
              );
              if (altLink) {
                _menu.push({
                  text: item?.text,
                  icon: item?.icon,
                  link: altLink,
                });
              }
            }
          }
        });
        if (!_allowedRoutes?.includes("dashboard")) {
          _menu.unshift({
            text: "",
            link: "home",
            icon: <HomeOutlined style={{ fontSize: "18px" }} />,
          });
        }
        dispatch(updateMenuData(_menu));
        dispatch(updateAllowedRoutes(_allowedRoutes));
      } catch (error) {
        console.log("error", error);
      }
    }
  }, [currentUser]);

  useEffect(() => {
    const isAuthenticated = Cookies.get("access-token");
    if (!isAuthenticated && !globalRoutes?.includes(window.location.pathname)) {
      window.location.href = "/";
    }
  }, []);

  return (
    <Routes>
      <Route path={`${process.env.PUBLIC_URL}`} element={<Layout />}>
        <Route path="home" element={<DefaultDashboardPage />} />
        {accessibility?.map(
          (path) =>
            routesMap[path] && (
              <Route key={path} path={path} element={routesMap[path]} />
            )
        )}
        {restrictedRoutes?.map((path) => (
          <Route path={path} element={<div> Unauthorized Access</div>} />
        ))}
        <Route path="notifications" element={<NotificationMain />} />
        {/* <Route path="viewhistory" element={<VersionControlDefaultTemplate />} /> */}
        <Route path="viewhistory" element={<VersionControl />} />
        <Route path="poHistory/:orderNumber" element={<POVersionControl />} />
        <Route path="prHistor" element={<PRVersionControl />} />
        <Route path="privacy" element={<Faq />}></Route>
        <Route
          path="user-profile-regular"
          element={<UserProfileRegular />}
        ></Route>
        <Route
          path="user-profile-notification"
          element={<UserProfileNotification />}
        ></Route>
        <Route
          path="user-profile-activity"
          element={<UserProfileActivity />}
        ></Route>
        <Route
          path="excelexport-requested-list"
          element={<ExcelExportRequestedList />}
        ></Route>
        <Route path="bulk-upload-list" element={<BulkUploadList />}></Route>
        <Route
          path="user-profile-setting"
          element={<UserProfileSetting />}
        ></Route>
      </Route>

      <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
        <Route path="auth-success" element={<Success />}></Route>
        <Route path="auth-reset" element={<ResetPassword />}></Route>
        <Route path="auth-register" element={<Register />}></Route>
        <Route index element={<Login setIsLoggedIn={setIsLoggedIn} />}></Route>
        <Route path="setPassword" element={<SetPassword />}></Route>
        <Route path="success" element={<SuccessMain />}></Route>
        <Route path="errorEmail" element={<EmailError />}></Route>

        <Route
          path="*"
          element={
            accessibility.length === 0 ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <Error404Modern />
            )
          }
        ></Route>
      </Route>
    </Routes>
  );
};
export default Pages;
